// Payload sizes are decoded JSON estimates, not compressed network bytes.
let recovery:
  | {
      started: number
      notifications: number
      notificationBytes: number
      ids: Set<string>
      requests: number
      replayRows: number
      rows: number
      dataBytes: number
      timeline: Record<string, number>
    }
  | undefined

export const recoveryDebug = {
  start(since: string) {
    recovery = {
      started: performance.now(),
      notifications: 0,
      notificationBytes: 0,
      ids: new Set(),
      requests: 0,
      replayRows: 0,
      rows: 0,
      dataBytes: 0,
      timeline: {}
    }
    console.info("[recovery] Starting from", since)
  },
  /** Seconds since the start at which a phase completed; the Finished line lists them. */
  mark(phase: string) {
    if (recovery)
      recovery.timeline[phase] = +((performance.now() - recovery.started) / 1000).toFixed(2)
  },
  notification(message: any) {
    if (!recovery) return
    recovery.notifications++
    recovery.notificationBytes += new TextEncoder().encode(JSON.stringify(message)).length
    const data = message.details?.data
    const ids =
      data?.ids ?? (Array.isArray(data) ? data : [data]).map((row) => row?.id).filter(Boolean)
    for (const id of ids) recovery.ids.add(`${message.details.model}:${id}`)
  },
  replayed(rows: unknown[]) {
    if (recovery) recovery.replayRows += rows.length
  },
  fetched(
    model: string,
    requested: number,
    rows: unknown[],
    milliseconds: number,
    source: "map" | "http"
  ) {
    const bytes = new TextEncoder().encode(JSON.stringify(rows)).length
    if (recovery) {
      recovery.requests++
      recovery.rows += rows.length
      recovery.dataBytes += bytes
      this.mark(`fetched ${model}`)
    }
    console.info(
      "[recovery] Object retrieval",
      JSON.stringify({
        source,
        model,
        requested,
        returned: rows.length,
        jsonKiB: +(bytes / 1024).toFixed(1),
        milliseconds: Math.round(milliseconds)
      })
    )
  },
  finish(success: boolean) {
    if (!recovery) return
    console.info(
      "[recovery] Finished",
      JSON.stringify({
        success,
        notifications: recovery.notifications,
        uniqueIds: recovery.ids.size,
        notificationJsonKiB: +(recovery.notificationBytes / 1024).toFixed(1),
        httpRequests: recovery.requests,
        rowsFromReplay: recovery.replayRows,
        rowsFetched: recovery.rows,
        dataJsonKiB: +(recovery.dataBytes / 1024).toFixed(1),
        seconds: +((performance.now() - recovery.started) / 1000).toFixed(2),
        timeline: recovery.timeline
      })
    )
    recovery = undefined
  }
}
